import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {
  Row,
  Col,
  ButtonToolbar,
  Button,
  Spinner,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import renderDatePickerField from "../../../../shared/components/form/DatePicker";
import { validateActivityLogSearch } from "./validateSearch";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permissions.constants";
import IssuersDropDown from "../../../Issuers/IssuersDropDown";
import { HiOutlineAdjustments } from "react-icons/hi";
import AuditByDropdown from "./AuditByDropdown";
import { FiDownload } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";
import UserNameDropdown from "./UserNameDropdown";
import {
  csvResetActivityLogDownload,
  pdfResetActivtyLogDownload,
  resetStatements,
} from "../../actions/getActivityLog.actions";

let ActivityLogSearchForm = ({
  handleSubmit,
  reset,
  pristine,
  invalid,
  startDate,
  endDate,
  loading,
  dispatch,
  activityLogStatement,
  csvFormatDownload,
  pdfFormatDownload,
  handleDownload,
}) => {
  const [dropDownOpen, setDropDownOpen] = useState(false);

  const resetForm = () => {
    reset();
    dispatch(csvResetActivityLogDownload());
    dispatch(pdfResetActivtyLogDownload());
  };
  useEffect(() => {
    return () => {
      dispatch(resetStatements());
      dispatch(csvResetActivityLogDownload());
      dispatch(pdfResetActivtyLogDownload());
    };
  }, [dispatch]);

  const toggleDownload = () => {
    setDropDownOpen(!dropDownOpen);
  };

  const activityLogData =
    activityLogStatement && activityLogStatement.response
      ? activityLogStatement.response.content
      : [];

  return (
    <form className="form" onSubmit={handleSubmit}>
      <Row>
        <AccessControl
          allowedPermissions={[permissionsConstants.FETCH_ISSUER_CONFIGS]}
          renderNoAccess={() => (
            <Col lg="3">
              <UserNameDropdown required id="issuer" label="User Name" />
            </Col>
          )}
        >
          <Col lg="3">
            <IssuersDropDown required id="issuer" label="Name of Issuer" />
          </Col>
        </AccessControl>

        <Col lg="3">
          <AuditByDropdown required id="issuer" label="Audit By" />
        </Col>
      </Row>
      <Row>
        <Col lg="3">
          <div className="form__form-group">
            <span className="form__form-group-label required">Start Date</span>
            <div className="form__form-group-field">
              <Field
                id="startDate"
                name="startDate"
                dateFormat="dd/MM/yyyy"
                maxDate={endDate || new Date()}
                component={renderDatePickerField}
                placeholder="Choose Start Date"
              />
            </div>
          </div>
        </Col>
        <Col lg="3">
          <div className="form__form-group">
            <span className="form__form-group-label required">End Date</span>
            <div className="form__form-group-field">
              <Field
                id="endDate"
                name="endDate"
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                minDate={startDate}
                component={renderDatePickerField}
                placeholder="Choose End Date"
              />
            </div>
          </div>
        </Col>
        <Col lg="4">
          <ButtonToolbar className="mt-4 form__button-toolbar">
            <Button
              className="btn-filter"
              type="submit"
              id="btn-submit-cardStatement"
              disabled={loading || invalid}
            >
              Apply Filter &nbsp;&nbsp;
              {loading ? (
                <span>
                  <Spinner size="sm" color="default" />
                </span>
              ) : (
                <HiOutlineAdjustments size={"1.5em"} />
              )}
            </Button>
            <Button
              type="button"
              id="btn-reset-cardStatement"
              onClick={resetForm}
              disabled={pristine || loading}
            >
              Reset
            </Button>
          </ButtonToolbar>
        </Col>

        <Col lg="2" className="text-right mt-4">
          <ButtonDropdown
            isOpen={dropDownOpen}
            toggle={toggleDownload}
            className="mb-1"
          >
            <DropdownToggle
              color="primary"
              className="btn-primary drop-toggle"
              disabled={!activityLogData.length || activityLogStatement.loading}
            >
              Download &nbsp;&nbsp;&nbsp;
              {activityLogStatement.loading ? (
                <span className="mr-3">
                  <Spinner size="sm" color="default" />
                </span>
              ) : (
                <IoIosArrowDown size={"1.6em"} />
              )}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem header className="drop-center">
                <div onClick={() => handleDownload("CSV")}>
                  <span>as CSV</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {csvFormatDownload.loading ? (
                    <span className="mr-3">
                      <Spinner size="sm" color="default" className="block" />
                    </span>
                  ) : (
                    <FiDownload size={"1.2em"} />
                  )}
                </div>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem header className="drop-center">
                <div onClick={() => handleDownload("PDF")}>
                  <span>as PDF</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {pdfFormatDownload.loading ? (
                    <span className="mr-3">
                      <Spinner size="sm" color="default" />
                    </span>
                  ) : (
                    <FiDownload size={"1.2em"} />
                  )}
                </div>
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
        </Col>
      </Row>
    </form>
  );
};

ActivityLogSearchForm = reduxForm({
  form: "activity_log_search",
  enableReinitialize: true,
  validate: validateActivityLogSearch,
})(ActivityLogSearchForm);

const selector = formValueSelector("activity_log_search");
ActivityLogSearchForm = connect((state) => {
  return {
    startDate: selector(state, "startDate"),
    endDate: selector(state, "endDate"),
  };
})(ActivityLogSearchForm);

export default ActivityLogSearchForm;
